import { Stepper, StepperProps } from "app/core/components/Stepper"

export const steps: StepperProps["steps"] = [
  {
    label: "Student Info",
    href: (params) => `/book-testing/join-group/${params.groupUuid}/1`,
  },
  {
    label: "Billing & Checkout",
    href: (params) => `/book-testing/join-group/${params.groupUuid}/2`,
  },
]

export const JoinGroupStepper = () => {
  return <Stepper steps={steps} />
}
